import { useState } from "react";
import styles from "./Schritte.module.css";

export default function Schritte({ onClose }) {
  const steps = [
    "Wir prüfen eure Angaben und melden uns bei euch.",
    "Wir besprechen eure Vorstellungen gemeinsam.",
    "Ihr erhaltet ein individuelles Catering-Angebot.",
    "Wir planen euer Event gemeinsam und führen es durch.",
  ];

  return (
    <div className={styles.backdrop} onClick={onClose}>
      <div className={styles.modal}>
        <button className={styles.closeButton} onClick={onClose}>
          ×
        </button>
        <h2 className={styles.title}>Was passiert als nächstes?</h2>
        <div className={styles.timeline}>
          {steps.map((step, index) => (
            <div key={index} className={styles.step}>
              <div className={styles.circle}>{index + 1}</div>
              <div className={styles.text}>{step}</div>
            </div>
          ))}
        </div>
        <p className={styles.footer}>Wir freuen uns auf euch!</p>
      </div>
    </div>
  );
}
